import { gql } from '../../../../__generated__';

export const UPDATE_E_PROCEEDING_STATUS = gql(`
 mutation UpdateEproceedingStatus($where: EProceedingUniqueIds!, $data: StatusUpdate!) {
  updateEproceedingStatus(where: $where, data: $data) {
    message
  }
}`);
